<ion-app>
  <app-session-status *ngIf="showSessionStatus$ | async"></app-session-status>
  <app-unlock *ngIf="this.isLocked"></app-unlock>
  <itl-maintenance-snack-bar *ngIf="!this.isLocked">
    <itl-split-pane></itl-split-pane>
  </itl-maintenance-snack-bar>
  <!-- Dev-only badge for active tenant config overrides -->
  <div
    *ngIf="hasOverrides$ | async"
    style="
      position: fixed;
      bottom: 12px;
      left: 12px;
      z-index: 9999;
      background: #c62828;
      color: #fff;
      padding: 6px 10px;
      border-radius: 4px;
      font-weight: 700;
      font-size: 12px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    "
    aria-label="Local tenant config overrides are active"
  >
    DEBUG: Config Overrides Active
    <a
      href="#"
      (click)="clearOverrides($event)"
      style="margin-left: 8px; color: #fff; font-weight: 700; text-decoration: underline"
      aria-label="Clear local tenant config overrides"
      >Clear</a
    >
  </div>
</ion-app>
